/**
 * Handle all the data needed for the frontend ( live ) to work
 * @creator Stefano
 * @date 26-6-2018
 */
import Handlebars from "handlebars/dist/handlebars.min.js";
import { sanitizeHtml } from "./utils/sanitizeHtml";

export default class Renderer {
    static registerPartial(name, templateString) {
        if (Handlebars.partials && Object.hasOwn(Handlebars.partials, name)) {
            console.warn(`Partial [${name}] already registered.`);
            return;
        }
        Handlebars.registerPartial(name, templateString);
    }

    static nativeInject(target, html, sanitizeOptions = {}) {
        let inject;
        if (target instanceof HTMLElement) {
            inject = target;
        } else {
            inject = document.getElementById(target);
        }
        if (!inject) {
            console.warn(`Element to inject not found [${target}]`);
            return;
        }
        inject.innerHTML = sanitizeHtml(html, sanitizeOptions);
    }

    static renderSource(source, data) {
        let template = Handlebars.compile(source);
        return template(data);
    }

    // static updateAdminBar( spread ){
    //     let btn = $('.admin-edit-btn');
    //     if(btn.length === 1){
    //         let editor;
    //         if( spread.spread_type === 1 ){
    //             editor = '/editor/app/';
    //         }else{
    //             editor = '/advancededitor/editor/';
    //         }
    //         let edit_url = `${dash_domain}/${btn.attr('href').split('/')[3]+editor+spread.issue_id}/${spread.spread_id}`;
    //         btn.attr('href', edit_url);
    //     }
    // }

    static inverseColors(scopeElement) {
        let names = [];
        scopeElement.querySelectorAll("[data-color-check]").forEach((e) => {
            if (!names[e.dataset.colorCheck]) {
                names[e.dataset.colorCheck] = [];
            }
            names[e.dataset.colorCheck].push(e);
        });

        for (let name in names) {
            this.applyColorCheck(name, names[name]);
        }
    }

    static applyColorCheck(name, elements) {
        let isLight = true;
        let backgroundElement = document.querySelector(`.${name}`);
        if (backgroundElement) {
            let hexcolor = window.getComputedStyle(backgroundElement).backgroundColor;
            hexcolor = this.getHex(hexcolor);
            // check if hexcolor is light or dark based on hex white
            isLight = parseInt(hexcolor, 16) > 0xffffff / 2;
        }

        if (isLight) {
            elements.forEach((node) => {
                node.classList.add("dark");
                node.classList.remove("light");
            });
        } else {
            elements.forEach((node) => {
                node.classList.add("light");
                node.classList.remove("dark");
            });
        }
    }

    static getHex(rgb) {
        let parts = rgb.match(/(\d{1,3}), (\d{1,3}), (\d{1,3})/);
        if (parts != null) {
            parts = parts.splice(1, 4).map(function (item) {
                let hex = parseInt(item, 10).toString(16);
                return hex.length === 1 ? "0" + hex : hex;
            });
            return parts.join("");
        }
        console.warn("could not convert rgb");
        return rgb;
    }
}
